import React, { useState, useEffect, useRef } from 'react';
import API from '../utils/api';

const EMPTY = { title: '', description: '', emoji: '🌸', badgeText: 'Special Offer', ctaText: 'Book Now' };

export default function AdminOffers() {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  const fileRef = useRef();

  const load = () => {
    setLoading(true);
    API.get('/offers').then(r => { if (r.data.success) setOffers(r.data.data); }).catch(() => { }).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!form.title.trim()) return;
    setSaving(true);
    const fd = new FormData();
    Object.entries(form).forEach(([k, v]) => fd.append(k, v));
    if (fileRef.current?.files[0]) fd.append('image', fileRef.current.files[0]);
    try {
      const r = await API.post('/offers', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      if (r.data.success) { setOffers(prev => [r.data.data, ...prev]); setForm(EMPTY); if (fileRef.current) fileRef.current.value = ''; }
    } catch (err) { alert(err.response?.data?.message || 'Failed'); }
    finally { setSaving(false); }
  };

  const activate = async (id) => {
    const r = await API.patch(`/offers/${id}/activate`);
    if (r.data.success) load(); // reload all to reflect single-active rule
  };

  const deactivate = async (id) => {
    await API.patch(`/offers/${id}/deactivate`);
    setOffers(prev => prev.map(o => o._id === id ? { ...o, active: false } : o));
  };

  const del = async (id) => {
    if (!window.confirm('Delete offer?')) return;
    await API.delete(`/offers/${id}`);
    setOffers(prev => prev.filter(o => o._id !== id));
  };

  return (
    <div className="admin-page">
      <div className="admin-page__header">
        <div>
          <h2 className="admin-page__title">Special Offers</h2>
          <p className="admin-page__sub">Only one offer can be active at a time. It shows as a popup on the customer site.</p>
        </div>
      </div>

      {/* Create form */}
      <div className="admin-card">
        <h3 className="admin-card__title">+ New Offer</h3>
        <form onSubmit={handleCreate} className="admin-form">
          <div className="admin-form__row">
            <div className="admin-fg">
              <label className="admin-fl">Title *</label>
              <input type="text" className="admin-fi" value={form.title}
                onChange={e => setForm(f => ({ ...f, title: e.target.value }))} placeholder="e.g. Exclusive Bridal Package" required />
            </div>
            <div className="admin-fg">
              <label className="admin-fl">Emoji Icon</label>
              <input type="text" className="admin-fi" value={form.emoji}
                onChange={e => setForm(f => ({ ...f, emoji: e.target.value }))} placeholder="🌸" />
            </div>
          </div>
          <div className="admin-fg">
            <label className="admin-fl">Description</label>
            <textarea className="admin-fi admin-fi--ta" rows={2} value={form.description}
              onChange={e => setForm(f => ({ ...f, description: e.target.value }))} placeholder="Short offer details…" />
          </div>
          <div className="admin-form__row">
            <div className="admin-fg">
              <label className="admin-fl">Badge Text</label>
              <input type="text" className="admin-fi" value={form.badgeText}
                onChange={e => setForm(f => ({ ...f, badgeText: e.target.value }))} placeholder="Special Offer" />
            </div>
            <div className="admin-fg">
              <label className="admin-fl">CTA Button Text</label>
              <input type="text" className="admin-fi" value={form.ctaText}
                onChange={e => setForm(f => ({ ...f, ctaText: e.target.value }))} placeholder="Book Now" />
            </div>
          </div>
          <div className="admin-fg">
            <label className="admin-fl">Poster Image (optional)</label>
            <input type="file" ref={fileRef} accept="image/*" className="admin-fi" />
          </div>
          <button type="submit" className="admin-btn admin-btn--primary" disabled={saving}>
            {saving ? 'Creating…' : 'Create Offer'}
          </button>
        </form>
      </div>

      {loading ? <div className="admin-loading">Loading…</div> : (
        <div className="admin-cards">
          {offers.length === 0 && <div className="admin-empty">No offers yet.</div>}
          {offers.map(o => (
            <div key={o._id} className={`admin-offer-card${o.active ? ' admin-offer-card--active' : ''}`}>
              <div className="admin-offer-card__top">
                {o.imageUrl
                  ? <img src={o.imageUrl} alt={o.title} className="admin-offer-card__img" />
                  : <div className="admin-offer-card__emoji">{o.emoji}</div>
                }
                <div className="admin-offer-card__info">
                  <div className="admin-offer-card__title">{o.title}</div>
                  <div className="admin-offer-card__desc">{o.description}</div>
                  <span className={`admin-badge ${o.active ? 'admin-badge--green' : 'admin-badge--grey'}`}>
                    {o.active ? '🟢 Active (showing on site)' : 'Inactive'}
                  </span>
                </div>
              </div>
              <div className="admin-offer-card__actions">
                {o.active
                  ? <button className="admin-btn admin-btn--outline admin-btn--sm" onClick={() => deactivate(o._id)}>Deactivate</button>
                  : <button className="admin-btn admin-btn--primary admin-btn--sm" onClick={() => activate(o._id)}>Set Active</button>
                }
                <button className="admin-btn admin-btn--danger admin-btn--sm" onClick={() => del(o._id)}>Delete</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
